/* eslint-disable no-console */
import people from '../../services/People';
import router from '../../router';

/* eslint-disable no-param-reassign */
export default {
  namespaced: true,
  state: {
    userAuthorization: null,
    data: null,
  },
  getters: {
    context(state) {
      if (!state.userAuthorization) return [];
      return state.userAuthorization;
    },
    domain(state) {
      if (!state.userAuthorization) return null;
      return state.userAuthorization.account.username.split('@')[1];
    },
    login(state) {
      if (!state.userAuthorization) return null;
      return state.userAuthorization.account.username.split('@')[0];
    },
    userName(state) {
      if (!state.userAuthorization) return null;
      return state.userAuthorization.account.username;
    },
    token(state) {
      if (!state.userAuthorization) return null;
      return state.userAuthorization.token;
    },
    data(state) {
      if (!state.data) return null;
      return state.data;
    },
    isApproving(state) {
      if (!state.data) return false;
      if (Number(state.data.personRoles.length) === 0) return false;
      const role = state.data.personRoles.filter((pr) => Boolean(pr.role.isApprobation));
      return Number(role.length) !== 0;
    },
    isEncoder(state) {
      if (!state.data) return false;
      if (Number(state.data.personRoles.length) === 0) return false;
      const role = state.data.personRoles.filter((pr) => String(pr.role.key) === 'ENCODER');
      return Number(role.length) !== 0;
    },
    isAdministrator(state) {
      if (!state.data) return false;
      if (Number(state.data.personRoles.length) === 0) return false;
      const role = state.data.personRoles.filter((pr) => String(pr.role.key) === 'ADMINISTRATOR');
      return Number(role.length) !== 0;
    },
    isApproverAdm(state) {
      if (!state.data) return false;
      if (Number(state.data.personRoles.length) === 0) return false;
      const role = state.data.personRoles.filter((pr) => String(pr.role.key) === 'APPROVER_ADM');
      return Number(role.length) !== 0;
    },
    isVolunteer(state) {
      if (!state.data) return false;
      return state.data.volunteer;
    },
  },
  actions: {
    async loadAuthorization({ getters, commit, rootState }, authenticationContext) {
      try {
        commit('updateUserAuthorization', authenticationContext);
        people.baseUrl = rootState.settings.apiBaseUrl;
        const data = await people.getPerson(getters.domain, getters.login);
        if (data[0] == null) {
          if (data[1] == null) router.push('AccessDenied').catch(() => {});
          commit('updateUserData', data[1]);
        }
      } catch (error) {
        console.log(error);
        router.push('Error').catch(() => {});
      }
    },
  },
  mutations: {
    updateUserAuthorization(state, data) {
      state.userAuthorization = data;
    },
    updateUserData(state, data) {
      state.data = data;
    },
  },
};
